'use strict';

const { SELECTORS } = require('./variables');
class Coupon {
    constructor() {
        this.initEvents();
    }

    /**
    * Set up event listeners for coupon and vorteilsprogramm actions
    */
    initEvents() {
        $('body').on('click', [SELECTORS.vorteilsprogramm, SELECTORS.vorteilsprogrammSwitchLabel, SELECTORS.proCouponBtn].join(', '), (ev) => {
            
            if (ev.target.classList.contains('js-coupon__description--modaltrigger')) {
                return;
            }

            ev.preventDefault();
            ev.stopImmediatePropagation();
            const uiState = this.getUIState(ev);
            const handler = this.actionMap[uiState.key] || this.defaultAction(uiState);
            handler(uiState);
        });
    }

    /**
    * Get the current UI state based on active coupons and promotions
    * @param {ev} event
    * @returns {Object} UI state including active statuses and coupon code
    */
    getUIState(ev) {
        const vorteilsProgrammActive = $(SELECTORS.vorteilsprogrammSwitchId).is(':checked');
        const button = ev.currentTarget;
        const origin = button.dataset.origin;
        const couponCode = button.dataset.code || document.querySelector(SELECTORS.vorteilsprogrammCode)?.dataset.code;
        const couponButtons = document.querySelectorAll(
            SELECTORS.couponsButtons
        );
        const couponActive = Array.from(couponButtons).some((btn) =>
            btn.classList.contains('cc-active')
        );
        const promotionActive = window.spsDataLayer.internal.promotionState.promotionActive || false;
  
        return {
            vorteilsProgrammActive,
            couponActive,
            promotionActive,
            couponCode,
            origin,
            key:
                '' +
                Number(vorteilsProgrammActive) +
                Number(couponActive) +
                Number(promotionActive) + '|' + origin
        };
    }

    uiState = {};

    // Key Order: vorteilsProgrammActive, couponActive, promotionActive | origin
    actionMap = {
        // coupon replace vp
        '100|coupon': (uiState) => { this.showReplaceModal(uiState); },
        // vp replace coupon
        '011|vp'    : (uiState) => { this.showReplaceModal(uiState); },
        // Nothing activ
        '000|coupon': (uiState) => { this.applyCouponDirect(uiState); },
        '000|vp': (uiState) => { this.applyCouponDirect(uiState); },
        //coupon replace promo
        '001|coupon': (uiState) => { this.showReplaceModal(uiState); },
        // vp replace promo
        '001|vp'    : (uiState) => { this.showReplaceModal(uiState); },
        //vp removed
        '100|vp'    : (uiState) => { this.removeCoupon(uiState); },
        // coupon replace coupon
        '011|coupon': (uiState) => { this.showReplaceModal(uiState); },
    };

    /**
    * Callback for unhandled UI states
    * @param {uiState} uiState - The current UI state
    */
    defaultAction(uiState) {
        console.warn('Default handler', uiState);
    }

    /**
    * Apply the coupon code directly without further prompts
    * @param {uiState} uiState - The current UI state
    */
    applyCouponDirect = (uiState) => {
        $(SELECTORS.couponCodeInput).val(uiState.couponCode);
        $('body').trigger('coupon:apply');
    };

    showReplaceModal = (uiState) => {
        $(SELECTORS.proCouponConfirm).attr('data-code', uiState.couponCode);
        $(SELECTORS.proCouponConfirm).attr('data-promotionChange', this.decodeKey(uiState.key));
        $(SELECTORS.proCouponModal).modal('show');
        $(`.case_${uiState.key.replace('|', '-')}`).removeClass('d-none');
    };

    removeCoupon = () => {
        $(SELECTORS.removeCoupon).first().trigger('click');
    }

    /**
    * Decode the UI state key into a human-readable format
    * @param {key} key - Encoded UI state key
    * @returns {string} Decoded state description
    */
    decodeKey(key) {
        const [bits, origin] = key.split('|');
        const [vp, coupon, promo] = bits.split('').map(b => b === '1');
        const activeStates = [];

        if (vp) activeStates.push('vorteilsProgramm');
        if (coupon) activeStates.push('coupon');
        if (promo) activeStates.push('promotion');

        const stateStr = activeStates.length ? activeStates.join('+') : 'none';

        return `${origin}::${stateStr}`;
    }
}

module.exports = Coupon;